import axios from "axios";
// List products with Api
export const GetContentCourseLevel = async (course_level_id,languaje,jwt,user_id) => {

  let url = process.env.REACT_APP_ADMIN_API_URL + `/contentCourseLevel`
  let data = "";
  let qs = require('qs');
  data = qs.stringify({
    'course_level_id': course_level_id,
    'language_id': languaje,
    'user_id': user_id
  });
  try {
    const response = await axios.post(
        url,
        data,
      {
        headers: {
            'Authorization': 'Bearer '+jwt, 
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
    return response.data

  } catch (error) {
      console.log(error)
      sessionStorage.removeItem('userSelect');
    throw error;
  }
};